import React, { useState, useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../../../config/firebase';
import { trackEvent, trackException, clearUserContext } from '../../../config/appInsights';
import LogoutContent from 'components/authentication/LogoutContent';

const Logout = () => {
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    signOut(auth)
      .then(() => {
        // Track successful logout
        trackEvent('UserLogout', {
          logoutMethod: 'manual',
          timestamp: new Date().toISOString()
        });
        
        // Clear user context from Application Insights
        clearUserContext();
        
        setSuccess(true);
      })
      .catch((error) => {
        // Track logout error
        trackException(error, {
          operation: 'UserLogout',
          errorCode: error.code
        });
        
        trackEvent('LogoutFailed', {
          errorCode: error.code,
          errorMessage: error.message
        });
        
        setError(error.message);
      });
  }, []);

  return (
    <div className='text-center'>
      <LogoutContent error={error} success={success} />
    </div>
  );
};

export default Logout;
